import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { UtilButton } from 'UI';

const { Box, Title, Button } = vp;
type FC = FunctionComponent;
const Inverite: FC = () => {
  const history = useHistory();
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.Inverite' });
  const { t: tInt } = useTranslation('translations', { keyPrefix: 'Integrations' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  return (
    <div>
      <Box flx="col" mb="md" gapSize="16px">
        <UtilButton
          iconLeft="chevron_left"
          size="large"
          onClick={() => {
            if (history.length > 1) {
              history.goBack();
            } else {
              history.replace('/integrations');
            }
          }}
        >
          {history.length > 1 ? tGlobal('Buttons.back') : tInt('pageTitle')}
        </UtilButton>
        <Title title={t('pageTitle')} />
      </Box>
      <Box flx="col">
        <Box mb="sm" flx="row">
          <div>
            <Trans
              ns="translations"
              i18nKey="Integrations.Inverite.introDescription"
              components={{
                uLink: (
                  <a href="https://vopay.com/inverite/" target="_blank" rel="noreferrer">
                    <u />
                  </a>
                ),
              }}
            />
          </div>
        </Box>
        <Box mb="sm">
          <strong>{t('sandboxApiLabel')}</strong>: https://earthnode-dev.vopay.com/api/v2
        </Box>
        <Box mb="sm">{t('workflowIntro')}</Box>
        <Box mb="sm" ps="lg">
          <ol>
            <li>{t('stepCreateRequestGuid')}</li>
            <li>{t('stepNavigateLogin')}</li>
            <li>{t('stepSelectInstitution')}</li>
            <li>{t('stepLoginBank')}</li>
            <li>{t('stepSelectAccount')}</li>
            <li>{t('stepCallApiWithGuid')}</li>
            <li>{t('stepFetchAccountDetails')}</li>
          </ol>
        </Box>

        <Box mt="lg" jc="fe">
          <Box>
            <Button
              id="Inverite-update"
              label={tGlobal('Buttons.update')}
              onClick={() => {
                history.push('/integrations/Inverite/update');
              }}
            />
          </Box>
        </Box>
      </Box>
    </div>
  );
};
export default Inverite;
